<template>
	<section class="body">
		<main class="container mt-6 py-12">
			<div class="row">
				<div class="col mt-6 text-center">
					<h2 v-if="$parent.guest.tmpGender > 0" class="fullwidth my-12">{{ $t('checkin.endtitle') }}<br /><span v-if="$parent.guest.tmpGender == 1">{{ $t('booking.bookingtable.tableheader.genders.mrs') }}</span><span v-else>{{ $t('booking.bookingtable.tableheader.genders.mr') }}</span> {{firstname }} {{ lastname }}</h2>
					<h2 v-else class="fullwidth my-8">{{ $t('checkin.endtitle') }}<br />{{ firstname }} {{ lastname }}</h2>


					<p class="mb-4">{{ $t('checkin.welcome.etage.intro') }}</p>

          <table class="mx-auto mb-8">
            <tbody>
              <tr>
                <th>{{ $t('booking.roomstable.tableheader.roomnumber') }}:</th>
                <td><h2 class="zimmer">{{ roomInfo.roomNumber }}</h2></td>
              <!-- not needed anymore
              </tr>
              <tr>
              -->
                <th class="etage">{{ $t('booking.roomstable.tableheader.roomfloor') }}:</th>
                <td><h2 class="zimmer">{{ roomInfo.floor }}</h2></td>
                <!--
                <td><h2 class="zimmer"><span v-if="roomInfo.floor < 1">{{ $t('checkin.welcome.etage.atZeroFloor') }}</span><span v-if="roomInfo.floor > 0">{{ $t('checkin.welcome.etage.atMoreFloor') }}</span> {{ roomInfo.floor }}<span v-if="roomInfo.floor < 1">{{ $t('checkin.welcome.etage.zero') }}</span><span v-if="roomInfo.floor > 0">{{ $t('checkin.welcome.etage.more') }}</span></h2></td>
                -->
              </tr>
            </tbody>
          </table>

					<p class="mb-4">{{ $t(config.texts.keyboy) }}</p>

					<h1 class="keyboy mb-4" v-if="finishAll">{{ code }}</h1>

					<p class="mb-8">
						{{ $t(config.texts.infoKey) }}<br/>
						{{ $t('checkin.welcome.aufenthalt') }}<br />
					</p>
					<p class="mb-8 alert alert-danger">
						{{ $t('checkin.welcome.please_come') }}
					</p>
					<div class="row pt-3" v-if="!finishAll">
						<div class="col-md-12 text-center" >
							<button class="btn btn-primary btn-next" @click.prevent="finishCheckIn"  type="submit">{{ $t('checkin.welcome.code') }}</button>
						</div>
					</div>

					<div class="row pt-3" v-if="finishAll">
						<div class="col-md-12 text-center btn-end">
							<button class="btn btn-primary btn-next" @click.prevent="lastStep"  type="submit">{{ $t('checkin.welcome.beenden') }} in {{ countDown }}</button>
              <!-- <span class="timer">{{ countDown }}</span> -->
						</div>
					</div>
				</div>
			</div>
		</main>
	</section>
</template>

<script>

	import axios from 'axios'
	import moment from 'moment'
  import { mapState } from 'vuex';

  export default {
        props: [],
        data: function () {
            return {
            	gender: this.$parent.guest.gender,
	            firstname: this.$parent.guest.firstname,
	            lastname: this.$parent.guest.lastname,
            	code: this.$parent.guest.keyBoyCode,
	            roomNumber: this.$parent.guest.roomNumber,
	            finishAll: true,
	            roomInfo: {
                roomNumber: null,
                floor: null
              },
              countDown: 0,
              countStart: 60,
              countDownTimerFunc: null,
              countDownTimeout: null
            }
        },
      computed: {
			  ...mapState('settings', ['config']),
		  },
	    created: function() {
		    let formData = new FormData();
		    formData.append('roomNumber', this.$parent.guest.roomNumber);

		    axios({
			    method: 'post',
			    url: this.config.apiUrl + 'getRoomInfo',
          withCredentials: true,
			    data: formData
		    }).then(response => (
			    this.roomInfo = response.data.returnValue,
          this.roomInfo.floor = this.roomInfo.floor == 0 ? 'EG' : this.roomInfo.floor,
			    this.finishAll = true
		    ));
        this.startCountDown();
      },
      methods: {
        lastStep() {
          const self = this;
          // this.$parent.guest = null;
          clearInterval(self.countDownTimerFunc);
          clearTimeout(self.countDownTimeout);
          this.$parent.component = 'CheckinStart';
        },
        startCountDown() {
          const self = this;
          self.countDown = self.countStart;
          self.countDownTimerFunc = setInterval(function() {
            // console.log(self.countDown);
            self.countDown--;
          },1000);
          self.countDownTimeout = setTimeout(function() {
          clearInterval(self.countDownTimerFunc);
            // console.log("OK");
            self.$parent.component = 'CheckinStart';
          },( (self.countStart) *1000) );
        }
      },
      components: {}
    }
</script>

<style scoped lang="scss">

  .btn {
    &.btn-primary
    {
      &.btn-next {
        width: 130%;
      }
    }
  }

  table {
    tr {
      th {
        font-size: 1.75rem;
        text-align: right;
      }
      td {
        text-align: left;
        padding-left: 30px;
      }
    }
  }

  h2 {
    &.zimmer {
      -webkit-text-fill-color: #F7E28A;
      color: #F7E28A;
      font-size: 80px;
      font-weight: bold;
    }
  }

  table th.etage {
    padding-left: 50px;
  }

  h1.keyboy {
    font-size: 90px;
    font-weight: bold;
  }
</style>
